<mat-tab-group
  *ngIf="panelList.length"
  class="doc-tab-group"
  color="primary"
  animationDuration="200ms">
  <mat-tab *ngFor="let p of panelList" [label]="p.label">
    <ng-container *ngTemplateOutlet="p.tpl"></ng-container>
  </mat-tab>
</mat-tab-group>
